// Prevent mobile nav flashing on page load
var style = document.createElement('style');
style.innerHTML = '.site-header .navigation {display: none;}';

document.getElementsByTagName('head')[0].appendChild(style);

(function ($) {
    $(function () {
        /** Append main menu toggle button */
        $('.site-header .bottom-bar .bottom-bar__cta-links').append('<button class="nav-toggle"><img srcset="/wp-content/themes/castlegate-balloon-tree/content/images/icons/menu.png 1x, /wp-content/themes/castlegate-balloon-tree/content/images/icons/menu-2x.png 2x", src="/wp-content/themes/castlegate-balloon-tree/content/images/icons/menu.png" alt="Menu" /></button>');

        /** Append subnav toggle button */
        $('.site-header .menu-item-has-children > a').append('<button class="submenu-toggle"><img src="/wp-content/themes/castlegate-balloon-tree/content/images/icons/sub-menu-arrow.png" alt="Menu" /></button>');

        /** Declare variables */
        var header = $('.site-header');
        var nav = $('.site-header .navigation');
        var navToggle = $('.site-header .nav-toggle');
        var subMenu = $('.sub-menu');

        /** Add/remove classes when JS is enabled */
        nav.addClass('navigation--hidden navigation--js-ready');
        subMenu.addClass('sub-menu--hidden');
        header.find('.bottom-bar').addClass('bottom-bar--js-ready');

        /** Nav toggle functionality */
        navToggle.on('click', function () {
            $(this).toggleClass('nav-toggle--active');
            nav.toggleClass('navigation--hidden');
            nav.toggleClass('navigation--active');
            header.find('.bottom-bar').toggleClass('bottom-bar--nav-active');
        });


        /** Subnav toggle functionality */
        $('.submenu-toggle').each(function (e) {

            $(this).on('click', function (e) {

                e.stopPropagation();
                e.preventDefault();

                var submenu = $(this).parent('a').next('.sub-menu');
                var parentAnchorTag = $(this).parent('a');

                /**
                 * Remove active states from all menu toggle buttons except the current one
                 */
                $(this).toggleClass('submenu-toggle--active');
                $('.submenu-toggle').not($(this)).removeClass('submenu-toggle--active');

                /**
                 * Hide all submenus except for the current one
                 */
                $('.sub-menu').not(submenu).removeClass('sub-menu--active');
                $('.sub-menu').not(submenu).addClass('sub-menu--hidden');
                $('.menu-item-has-children > a').not(parentAnchorTag).removeClass('active');

                /**
                 * Toggle the active and hidden classes of the current submenu
                 */
                submenu.toggleClass('sub-menu--hidden');
                submenu.toggleClass('sub-menu--active');
                parentAnchorTag.toggleClass('active');

                if (submenu.hasClass('sub-menu--active')) {
                    $('body').addClass('nav-active');
                } else {
                    $('body').removeClass('nav-active');
                }

            });

            /**
             * Remove active states when user clicks anywhere else on the page
             */
            $('html body').on('click', function () {
                $('.submenu-toggle').removeClass('submenu-toggle--active');
                $('.sub-menu').removeClass('sub-menu--active');
                $('.sub-menu').addClass('sub-menu--hidden');
                $('.menu-item-has-children > a').removeClass('active');
                $('body').removeClass('nav-active');
            });
        });
    });
})(jQuery);